import React from 'react';
export const Nav00DataSource = {
  wrapper: { className: 'header0 home-page-wrapper' },
  page: { className: 'home-page' },
  logo: {
    className: 'header0-logo',
    children:
      'https://www.wshoto.com/resource/website_new/images/index-nav-logo.png?v=1',
  },
  Menu: {
    className: 'header0-menu',
    children: [
      {
        name: 'item0',
        className: 'header0-item',
        children: {
          href: '/wi_website_index.php',
          children: [
            {
              children: (
                <>
                  <p>首页</p>
                </>
              ),
              name: 'text',
            },
          ],
        },
        subItem: null,
      },
      {
        name: 'item1',
        className: 'header0-item',
        children: {
          href: '/wi_website_product.php',
          children: [
            {
              children: (
                <>
                  <p>
                    <span>产品中心</span>
                    <br />
                  </p>
                </>
              ),
              name: 'text',
            },
          ],
        },
        subItem: null,
      },
      {
        name: 'item2',
        className: 'header0-item',
        children: {
          href: '/wi_website_case.php',
          children: [
            {
              children: (
                <>
                  <p>案例中心</p>
                </>
              ),
              name: 'text',
            },
          ],
        },
        subItem: null,
      },
      {
        name: 'item3',
        className: 'header0-item',
        children: {
          href: '/wi_website_product-manual.php',
          children: [
            {
              children: (
                <>
                  <p>
                    <span>帮助中心</span>
                    <br />
                  </p>
                </>
              ),
              name: 'text',
            },
          ],
        },
      },
      {
        name: 'item~k315jln721q',
        className: 'header0-item',
        children: {
          href: '/wi_website_joinin.php',
          children: [
            {
              children: (
                <>
                  <p>合作伙伴</p>
                </>
              ),
              name: 'text',
            },
          ],
        },
      },
      {
        name: 'item~k315kgkx2m',
        className: 'header0-item',
        children: {
          href: '/wi_website_news.php',
          children: [
            {
              children: (
                <>
                  <p>
                    <span>企微学院</span>
                    <br />
                  </p>
                </>
              ),
              name: 'text',
            },
          ],
        },
      },
      {
        name: 'item~k315kqbkra',
        className: 'header0-item',
        children: {
          href: '/wi_website_aboutus.php',
          children: [
            {
              children: (
                <>
                  <p>
                    <span>了解微盛</span>
                    <br />
                  </p>
                </>
              ),
              name: 'text',
            },
          ],
        },
      },
      {
        name: 'item~k481t05n1i',
        className: 'header0-item',
        children: {
          href: '/wi_user_login.php',
          children: [
            {
              children: (
                <>
                  <p>登录</p>
                </>
              ),
              name: 'text',
            },
          ],
        },
      },
    ],
  },
  mobileMenu: { className: 'header0-mobile-menu' },
};
export const Banner30DataSource = {
  wrapper: { className: 'banner3 k31bfwc7k9-editor_css' },
  textWrapper: {
    className: 'banner3-text-wrapper k3166u8abp-editor_css',
    children: [
      {
        name: 'nameEn',
        className: 'banner3-name-en k31bmzd8ay-editor_css',
        children: (
          <>
            <p>
              <br />
            </p>
          </>
        ),
      },
      {
        name: 'slogan',
        className: 'banner3-slogan k3161gnsy9-editor_css',
        children: '微盛SCRM小程序全面深度集成企业微信',
        texty: true,
      },
      {
        name: 'name',
        className: 'banner3-name k47wsih1pkf-editor_css',
        children: (
          <>
            <p>
              企业微信+小程序 打造企业数字化转型闭环<br />
            </p>
          </>
        ),
      },
      {
        name: 'button',
        className: 'banner3-button k32rfy3lf56-editor_css',
        children: (
          <>
            <p>免费试用</p>
          </>
        ),
        href: 'https://www.wshoto.com/wi_user_login.php',
        target: '_blank',
        type: 'primary',
      },
      {
        name: 'button~k3168n14y2',
        className:
          'ant-btn-primary ant-btn banner3-button ant-btn-default k3168ouqrl7-editor_css',
        children: (
          <>
            <p>立即咨询</p>
          </>
        ),
        type: 'default',
        href: 'http://wpa.qq.com/msgrd?v=3&amp;uin=&amp;site=qq&amp;menu=yes',
        target: '_blank',
      },
    ],
  },
};
export const Feature00DataSource = {
  wrapper: { className: 'home-page-wrapper content0-wrapper' },
  page: { className: 'home-page content0' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <>
            <p>企微SCRM·私域方案</p>
          </>
        ),
      },
      {
        name: 'title~k5lwxw5r5uq',
        className: 'k5lwxxlasyk-editor_css',
        children: (
          <>
            <p>应用场景&nbsp;</p>
          </>
        ),
      },
      {
        name: 'title~k5lx063gg9o',
        className: 'k5lx09xlpi-editor_css',
        children: (
          <>
            <p>
              多行业的SCRM和私域方案，助力企业基于企业微信实现私域数据经营轻闭环。
            </p>
          </>
        ),
      },
      {
        name: 'title~k5lx30lyvbd',
        className: 'k5lx32yf5p-editor_css',
        children: (
          <>
            <p>主要功能点&nbsp;</p>
          </>
        ),
      },
    ],
  },
  childWrapper: {
    className: 'content0-block-wrapper',
    children: [
      {
        name: 'block0',
        className: 'content0-block',
        md: 8,
        xs: 24,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon',
              children:
                'https://zos.alipayobjects.com/rmsportal/WBnVOjtIlGWbzyQivuyq.png',
            },
            {
              name: 'title',
              className: 'content0-block-title',
              children: (
                <>
                  <p>触达引流&nbsp;</p>
                </>
              ),
            },
            {
              name: 'content',
              children: (
                <>
                  <p>
                    种子用户画像，通过社交广告等精准投放获客，借助于营销海报，直播抽奖，拼团等线上线下营销活动进行扩散引流。
                  </p>
                </>
              ),
              className: 'k67m1kkrpu8-editor_css',
            },
          ],
        },
      },
      {
        name: 'block1',
        className: 'content0-block',
        md: 8,
        xs: 24,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon',
              children:
                'https://zos.alipayobjects.com/rmsportal/YPMsLQuCEXtuEkmXTTdk.png',
            },
            {
              name: 'title',
              className: 'content0-block-title',
              children: (
                <>
                  <p>沟通转化</p>
                </>
              ),
            },
            {
              name: 'content',
              children: (
                <>
                  <p>
                    微信端跟进助手实时进行全面的客户管理，访客提醒、记录访客行为轨迹、不加好友直接聊天、写跟进、打标签、看画像、1v1精准营销、1v多标签化精准群发
                  </p>
                </>
              ),
              className: 'k67m6mux8a-editor_css',
            },
          ],
        },
      },
      {
        name: 'block2',
        className: 'content0-block',
        md: 8,
        xs: 24,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon',
              children:
                'https://zos.alipayobjects.com/rmsportal/EkXWVvAaFJKCzhMmQYiX.png',
            },
            {
              name: 'title',
              className: 'content0-block-title',
              children: (
                <>
                  <p>用户服务</p>
                </>
              ),
            },
            {
              name: 'content',
              children: (
                <>
                  <p>
                    订单提醒、售后提醒等企业微信通知让服务更及时；复购提醒、流失回访提醒的智能服务，实现千人千面，提高客户留存率和复购率。
                  </p>
                </>
              ),
              className: 'k67mbkskh5m-editor_css',
            },
          ],
        },
      },
    ],
  },
};
export const Feature20DataSource = {
  wrapper: {
    className: 'home-page-wrapper content2-wrapper k5lx8lyumrt-editor_css',
  },
  OverPack: { className: 'home-page content2', playScale: 0.3 },
  imgWrapper: {
    className: 'content2-img k5m2j2l068c-editor_css',
    md: 24,
    xs: 24,
  },
  img: {
    children: 'https://www.wshoto.com//attachment/website/file/1.png',
    className: 'k5lx8z7wep-editor_css',
  },
  textWrapper: {
    className: 'content2-text k5m2dqvujo-editor_css',
    md: 24,
    xs: 24,
  },
  title: {
    className: 'content2-title k5lx9uykfs-editor_css',
    children: (
      <>
        <p>企业私域数据经营闭环</p>
      </>
    ),
  },
  content: {
    className: 'content2-content k5lxb76p9wa-editor_css',
    children: (
      <>
        <p>
          <br />
        </p>
      </>
    ),
  },
};
export const Feature21DataSource = {
  wrapper: {
    className: 'home-page-wrapper content2-wrapper k5m2ub4vqmq-editor_css',
  },
  OverPack: { className: 'home-page content2', playScale: 0.3 },
  imgWrapper: {
    className: 'content2-img k5m34sei1a7-editor_css',
    md: 24,
    xs: 24,
  },
  img: {
    children: 'https://www.wshoto.com//attachment/website/file/2.png',
    className: 'k5m2vgovhg-editor_css',
  },
  textWrapper: {
    className: 'content2-text k5m2uaae9up-editor_css',
    md: 24,
    xs: 24,
  },
  title: {
    className: 'content2-title k5m2vzv8opf-editor_css',
    children: (
      <>
        <p>智能化用户全生命周期管理</p>
      </>
    ),
  },
  content: {
    className: 'content2-content',
    children: (
      <>
        <p>
          <br />
        </p>
      </>
    ),
  },
};
export const Teams11DataSource = {
  wrapper: {
    className: 'home-page-wrapper teams1-wrapper k67w71rnzp9-editor_css',
  },
  page: { className: 'home-page teams1' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <>
            <p>触达引流-百余种引流工具</p>
          </>
        ),
      },
      {
        name: 'title~k5lw9h2nyh',
        className: 'k5lw9m93kps-editor_css',
        children: (
          <>
            <p>
              可以通过小程序的拓客表单、直播抽奖、商品码以及客服等丰富形式，进行线上线下引流
            </p>
          </>
        ),
      },
    ],
  },
  block: {
    className: 'block-wrapper k67vtj9nbd-editor_css',
    children: [
      {
        name: 'block~k67wrs39nbf',
        className: 'block k5lw1986udt-editor_css',
        md: 4,
        xs: 8,
        titleWrapper: {
          children: [
            {
              name: 'image',
              className: 'teams1-image k5lw2z1ozi-editor_css',
              children:
                'https://www.wshoto.com//attachment/website/file/icon/1.png',
            },
            {
              name: 'title',
              className: 'teams1-title k5lw1reyeyj-editor_css',
              children: (
                <>
                  <p>拼团</p>
                </>
              ),
            },
          ],
        },
      },
      {
        name: 'block~k67wubn3fut',
        className: 'block k5lw1986udt-editor_css',
        md: 4,
        xs: 8,
        titleWrapper: {
          children: [
            {
              name: 'image',
              className: 'teams1-image k5lw2z1ozi-editor_css',
              children:
                'https://www.wshoto.com//attachment/website/file/icon/2.png',
            },
            {
              name: 'title',
              className: 'teams1-title k5lw1reyeyj-editor_css',
              children: (
                <>
                  <p>秒杀</p>
                </>
              ),
            },
          ],
        },
      },
      {
        name: 'block~k67wuc9sgy',
        className: 'block k5lw1986udt-editor_css',
        md: 4,
        xs: 8,
        titleWrapper: {
          children: [
            {
              name: 'image',
              className: 'teams1-image k5lw2z1ozi-editor_css',
              children:
                'https://www.wshoto.com//attachment/website/file/icon/3.png',
            },
            {
              name: 'title',
              className: 'teams1-title k5lw1reyeyj-editor_css',
              children: (
                <>
                  <p>砍价</p>
                </>
              ),
            },
          ],
        },
      },
      {
        name: 'block~k67wucr6gkf',
        className: 'block k5lw1986udt-editor_css',
        md: 4,
        xs: 8,
        titleWrapper: {
          children: [
            {
              name: 'image',
              className: 'teams1-image k5lw2z1ozi-editor_css',
              children:
                'https://www.wshoto.com//attachment/website/file/icon/4.png',
            },
            {
              name: 'title',
              className: 'teams1-title k5lw1reyeyj-editor_css',
              children: (
                <>
                  <p>抽奖</p>
                </>
              ),
            },
          ],
        },
      },
      {
        name: 'block~k67wud7g6g9',
        className: 'block k5lw1986udt-editor_css',
        md: 4,
        xs: 8,
        titleWrapper: {
          children: [
            {
              name: 'image',
              className: 'teams1-image k5lw2z1ozi-editor_css',
              children:
                'https://www.wshoto.com//attachment/website/file/icon/5.png',
            },
            {
              name: 'title',
              className: 'teams1-title k5lw1reyeyj-editor_css',
              children: (
                <>
                  <p>红包</p>
                </>
              ),
            },
          ],
        },
      },
      {
        name: 'block~k67wudp2klc',
        className: 'block k5lw1986udt-editor_css',
        md: 4,
        xs: 8,
        titleWrapper: {
          children: [
            {
              name: 'image',
              className: 'teams1-image k5lw2z1ozi-editor_css',
              children:
                'https://www.wshoto.com//attachment/website/file/icon/6.png',
            },
            {
              name: 'title',
              className: 'teams1-title k5lw1reyeyj-editor_css',
              children: (
                <>
                  <p>优惠券</p>
                </>
              ),
            },
          ],
        },
      },
      {
        name: 'block~k67wuelk00n',
        className: 'block k5lw1986udt-editor_css',
        md: 4,
        xs: 8,
        titleWrapper: {
          children: [
            {
              name: 'image',
              className: 'teams1-image k5lw2z1ozi-editor_css',
              children:
                'https://www.wshoto.com//attachment/website/file/icon/7.png',
            },
            {
              name: 'title',
              className: 'teams1-title k5lw1reyeyj-editor_css',
              children: (
                <>
                  <p>拓客表单</p>
                </>
              ),
            },
          ],
        },
      },
      {
        name: 'block~k67wuf7n24l',
        className: 'block k5lw1986udt-editor_css',
        md: 4,
        xs: 8,
        titleWrapper: {
          children: [
            {
              name: 'image',
              className: 'teams1-image k5lw2z1ozi-editor_css',
              children:
                'https://www.wshoto.com//attachment/website/file/icon/8.png',
            },
            {
              name: 'title',
              className: 'teams1-title k5lw1reyeyj-editor_css',
              children: (
                <>
                  <p>直播抽奖</p>
                </>
              ),
            },
          ],
        },
      },
      {
        name: 'block~k67wufox8me',
        className: 'block k5lw1986udt-editor_css',
        md: 4,
        xs: 8,
        titleWrapper: {
          children: [
            {
              name: 'image',
              className: 'teams1-image k5lw2z1ozi-editor_css',
              children:
                'https://www.wshoto.com//attachment/website/file/icon/9.png',
            },
            {
              name: 'title',
              className: 'teams1-title k5lw1reyeyj-editor_css',
              children: (
                <>
                  <p>短信营销</p>
                </>
              ),
            },
          ],
        },
      },
      {
        name: 'block~k67wug5vf3l',
        className: 'block k5lw1986udt-editor_css',
        md: 4,
        xs: 8,
        titleWrapper: {
          children: [
            {
              name: 'image',
              className: 'teams1-image k5lw2z1ozi-editor_css',
              children:
                'https://www.wshoto.com//attachment/website/file/icon/10.png',
            },
            {
              name: 'title',
              className: 'teams1-title k5lw1reyeyj-editor_css',
              children: (
                <>
                  <p>智能名片</p>
                </>
              ),
            },
          ],
        },
      },
      {
        name: 'block~k67wugm92ou',
        className: 'block k5lw1986udt-editor_css',
        md: 4,
        xs: 8,
        titleWrapper: {
          children: [
            {
              name: 'image',
              className: 'teams1-image k5lw2z1ozi-editor_css',
              children:
                'https://www.wshoto.com//attachment/website/file/icon/11.png',
            },
            {
              name: 'title',
              className: 'teams1-title k5lw1reyeyj-editor_css',
              children: (
                <>
                  <p>好友助力</p>
                </>
              ),
            },
          ],
        },
      },
      {
        name: 'block~k67wuh650f',
        className: 'block k5lw1986udt-editor_css',
        md: 4,
        xs: 8,
        titleWrapper: {
          children: [
            {
              name: 'image',
              className: 'teams1-image k5lw2z1ozi-editor_css',
              children:
                'https://www.wshoto.com//attachment/website/file/icon/12.png',
            },
            {
              name: 'title',
              className: 'teams1-title k5lw1reyeyj-editor_css',
              children: (
                <>
                  <p>积分商城</p>
                </>
              ),
            },
          ],
        },
      },
      {
        name: 'block~k67wui1bbz9',
        className: 'block k5lw1986udt-editor_css',
        md: 4,
        xs: 8,
        titleWrapper: {
          children: [
            {
              name: 'image',
              className: 'teams1-image k5lw2z1ozi-editor_css',
              children:
                'https://www.wshoto.com//attachment/website/file/icon/13.png',
            },
            {
              name: 'title',
              className: 'teams1-title k5lw1reyeyj-editor_css',
              children: (
                <>
                  <p>引流红包</p>
                </>
              ),
            },
          ],
        },
      },
      {
        name: 'block~k67wukee316',
        className: 'block k5lw1986udt-editor_css',
        md: 4,
        xs: 8,
        titleWrapper: {
          children: [
            {
              name: 'image',
              className: 'teams1-image k5lw2z1ozi-editor_css',
              children:
                'https://www.wshoto.com//attachment/website/file/icon/14.png',
            },
            {
              name: 'title',
              className: 'teams1-title k5lw1reyeyj-editor_css',
              children: (
                <>
                  <p>砸金蛋</p>
                </>
              ),
            },
          ],
        },
      },
      {
        name: 'block~k67wul22zqi',
        className: 'block k5lw1986udt-editor_css',
        md: 4,
        xs: 8,
        titleWrapper: {
          children: [
            {
              name: 'image',
              className: 'teams1-image k5lw2z1ozi-editor_css',
              children:
                'https://www.wshoto.com//attachment/website/file/icon/15.png',
            },
            {
              name: 'title',
              className: 'teams1-title k5lw1reyeyj-editor_css',
              children: (
                <>
                  <p>刮刮卡</p>
                </>
              ),
            },
          ],
        },
      },
      {
        name: 'block~k67wulvgibe',
        className: 'block k5lw1986udt-editor_css',
        md: 4,
        xs: 8,
        titleWrapper: {
          children: [
            {
              name: 'image',
              className: 'teams1-image k5lw2z1ozi-editor_css',
              children:
                'https://www.wshoto.com//attachment/website/file/icon/16.png',
            },
            {
              name: 'title',
              className: 'teams1-title k5lw1reyeyj-editor_css',
              children: (
                <>
                  <p>投票</p>
                </>
              ),
            },
          ],
        },
      },
      {
        name: 'block~k67wumh3xig',
        className: 'block k5lw1986udt-editor_css',
        md: 4,
        xs: 8,
        titleWrapper: {
          children: [
            {
              name: 'image',
              className: 'teams1-image k5lw2z1ozi-editor_css',
              children:
                'https://www.wshoto.com//attachment/website/file/icon/17.png',
            },
            {
              name: 'title',
              className: 'teams1-title k5lw1reyeyj-editor_css',
              children: (
                <>
                  <p>集卡</p>
                </>
              ),
            },
          ],
        },
      },
      {
        name: 'block~k67wunepj4i',
        className: 'block k5lw1986udt-editor_css',
        md: 4,
        xs: 8,
        titleWrapper: {
          children: [
            {
              name: 'image',
              className: 'teams1-image k5lw2z1ozi-editor_css',
              children:
                'https://www.wshoto.com//attachment/website/file/icon/18.png',
            },
            {
              name: 'title',
              className: 'teams1-title k5lw1reyeyj-editor_css',
              children: (
                <>
                  <p>更多</p>
                </>
              ),
            },
          ],
        },
      },
    ],
    gutter: 0,
  },
};
export const Feature22DataSource = {
  wrapper: {
    className: 'home-page-wrapper content2-wrapper k5m3mxe74v-editor_css',
  },
  OverPack: { className: 'home-page content2', playScale: 0.3 },
  imgWrapper: {
    className: 'content2-img k5m3n9n2cju-editor_css',
    md: 24,
    xs: 24,
  },
  img: {
    children: 'https://www.wshoto.com//attachment/website/file/3.png',
    className: 'k5m3n97ycqh-editor_css',
  },
  textWrapper: {
    className: 'content2-text k5m3i145d5c-editor_css',
    md: 24,
    xs: 24,
  },
  title: {
    className: 'content2-title k5m3gfc6ubm-editor_css',
    children: (
      <>
        <p>沟通转化-建立用户微信生态统一画像和CDP私域数据平台</p>
      </>
    ),
  },
  content: {
    className: 'content2-content k5m3i1ff72-editor_css',
    children: (
      <>
        <p>
          pc端实时同步小程序端及企业微信端的聊天会话、跟进记录、标签备注等，用户订单、消费明细积分余额等业务数据实时统计，全方位记录分析用户行为。
        </p>
      </>
    ),
  },
};
export const Feature02DataSource = {
  wrapper: { className: 'home-page-wrapper content0-wrapper' },
  page: { className: 'home-page content0' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <>
            <p>沟通转化-客户跟进助手促进转化</p>
          </>
        ),
      },
    ],
  },
  childWrapper: {
    className: 'content0-block-wrapper',
    children: [
      {
        name: 'block0',
        className: 'content0-block',
        md: 6,
        xs: 12,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon k5m4mkm6817-editor_css',
              children:
                'https://www.wshoto.com//attachment/website/file/trans1/1.png',
            },
            {
              name: 'content',
              children: (
                <>
                  <p>微信端导购工作台</p>
                </>
              ),
              className: 'k5m4n7ia1ra-editor_css',
            },
          ],
        },
      },
      {
        name: 'block~k5m4nxuqdq8',
        className: 'content0-block',
        md: 6,
        xs: 12,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon k5m4mkm6817-editor_css',
              children:
                'https://www.wshoto.com//attachment/website/file/trans1/2.png',
            },
            {
              name: 'content',
              children: (
                <>
                  <p>客户随时沟通跟进</p>
                </>
              ),
              className: 'k5m4n7ia1ra-editor_css',
            },
          ],
        },
      },
      {
        name: 'block~k5m4nyblvja',
        className: 'content0-block',
        md: 6,
        xs: 12,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon k5m4mkm6817-editor_css',
              children:
                'https://www.wshoto.com//attachment/website/file/trans1/3.png',
            },
            {
              name: 'content',
              children: (
                <>
                  <p>多种素材工具轻松互动</p>
                </>
              ),
              className: 'k5m4n7ia1ra-editor_css',
            },
          ],
        },
      },
      {
        name: 'block~k5m4nz36nv',
        className: 'content0-block',
        md: 6,
        xs: 12,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon k5m4mkm6817-editor_css',
              children:
                'https://www.wshoto.com//attachment/website/file/trans1/4.png',
            },
            {
              name: 'content',
              children: (
                <>
                  <p>导购券下发促成成交</p>
                </>
              ),
              className: 'k5m4n7ia1ra-editor_css',
            },
          ],
        },
      },
    ],
  },
};
export const Teams13DataSource = {
  wrapper: { className: 'home-page-wrapper teams1-wrapper' },
  page: { className: 'home-page teams1' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <>
            <p>沟通转化-微信生态用户身份识别构建用户统一画像</p>
          </>
        ),
      },
    ],
  },
  block: {
    className: 'block-wrapper k6afxb2nhyq-editor_css',
    children: [
      {
        name: 'block0',
        className: 'block',
        md: 8,
        xs: 24,
        titleWrapper: {
          children: [
            {
              name: 'image',
              className: 'teams1-image k6805nrrqyq-editor_css',
              children: 'https://www.wshoto.com//attachment/website/file/4.png',
            },
          ],
        },
      },
    ],
  },
};
export const Teams12DataSource = {
  wrapper: { className: 'home-page-wrapper teams1-wrapper' },
  page: { className: 'home-page teams1' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <>
            <p>沟通转化-标签体系，还原客户画像辅助销售沟通 </p>
          </>
        ),
      },
    ],
  },
  block: {
    className: 'block-wrapper k67z5dc5umo-editor_css',
    children: [
      {
        name: 'block0',
        className: 'block',
        md: 8,
        xs: 24,
        titleWrapper: {
          children: [
            {
              name: 'image',
              className: 'teams1-image k67z9gb1tm-editor_css',
              children: 'https://www.wshoto.com//attachment/website/file/5.png',
            },
          ],
        },
      },
    ],
  },
};
export const Feature01DataSource = {
  wrapper: { className: 'home-page-wrapper content0-wrapper' },
  page: { className: 'home-page content0' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <>
            <p>沟通转化-客户访问提醒&nbsp;沟通&nbsp;记录&nbsp;</p>
          </>
        ),
      },
      {
        name: 'title~k5m46dfck4',
        className: 'k5m46e8rfp-editor_css',
        children: (
          <>
            <p>
              可以根据客户的基础信息、接触点偏好、兴趣爱好、产品需求偏好、社交传播点等设置丰富标签，多触点标签同步，客户画像一目了然
            </p>
          </>
        ),
      },
    ],
  },
  childWrapper: {
    className: 'content0-block-wrapper ant-row k5m49nbh9y6-editor_css',
    children: [
      {
        name: 'block0',
        className: 'content0-block k67yo0cc0f7-editor_css',
        md: 6,
        xs: 12,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon k5m4aj9trw-editor_css',
              children:
                'https://www.wshoto.com//attachment/website/file/trans2/1.png',
            },
            {
              name: 'content',
              children: (
                <>
                  <p>用户访问企业微信提醒老板或销售</p>
                </>
              ),
              className: 'k5m4ah2uc0j-editor_css',
            },
          ],
        },
      },
      {
        name: 'block~k5m4i261awc',
        className: 'content0-block k67yonjap3c-editor_css',
        md: 6,
        xs: 12,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon k5m4aj9trw-editor_css',
              children:
                'https://www.wshoto.com//attachment/website/file/trans2/2.png',
            },
            {
              name: 'content',
              children: (
                <>
                  <p>用户访问企业微信提醒老板或销售</p>
                </>
              ),
              className: 'k5m4ah2uc0j-editor_css',
            },
          ],
        },
      },
      {
        name: 'block~k5m4i2lyz2',
        className: 'content0-block k67yp43mn-editor_css',
        md: 6,
        xs: 12,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon k5m4aj9trw-editor_css',
              children:
                'https://www.wshoto.com//attachment/website/file/trans2/3.png',
            },
            {
              name: 'content',
              children: (
                <>
                  <p>用户访问企业微信提醒老板或销售</p>
                </>
              ),
              className: 'k5m4ah2uc0j-editor_css',
            },
          ],
        },
      },
      {
        name: 'block~k5m4i3fznpd',
        className: 'content0-block k67yp8hbx48-editor_css',
        md: 6,
        xs: 12,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon k5m4aj9trw-editor_css',
              children:
                'https://www.wshoto.com//attachment/website/file/trans2/4.png',
            },
            {
              name: 'content',
              children: (
                <>
                  <p>用户访问企业微信提醒老板或销售</p>
                </>
              ),
              className: 'k5m4ah2uc0j-editor_css',
            },
          ],
        },
      },
      {
        name: 'block~k67yq9xk648',
        className: 'content0-block k67yp8hbx48-editor_css',
        md: 6,
        xs: 12,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon k5m4aj9trw-editor_css',
              children:
                'https://www.wshoto.com//attachment/website/file/trans2/5.png',
            },
            {
              name: 'content',
              children: (
                <>
                  <p>用户访问企业微信提醒老板或销售</p>
                </>
              ),
              className: 'k5m4ah2uc0j-editor_css',
            },
          ],
        },
      },
    ],
    gutter: 0,
  },
};
export const Feature04DataSource = {
  wrapper: { className: 'home-page-wrapper content0-wrapper' },
  page: { className: 'home-page content0' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <>
            <p>用户服务&nbsp;</p>
          </>
        ),
      },
      {
        name: 'title~k5m4v7ktll',
        className: 'k5m4v87m4oc-editor_css',
        children: (
          <>
            <p>售后提醒，客户回访精细化服务。&nbsp;</p>
          </>
        ),
      },
    ],
  },
  childWrapper: {
    className: 'content0-block-wrapper',
    children: [
      {
        name: 'block0',
        className: 'content0-block',
        md: 6,
        xs: 12,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon k5m4wbf615g-editor_css',
              children:
                'https://www.wshoto.com//attachment/website/file/user/1.png',
            },
            {
              name: 'content',
              children: (
                <>
                  <p>新订单通知</p>
                </>
              ),
              className: 'k5m4woqrgwg-editor_css',
            },
          ],
        },
      },
      {
        name: 'block~k5m4y1vhax',
        className: 'content0-block',
        md: 6,
        xs: 12,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon k5m4wbf615g-editor_css',
              children:
                'https://www.wshoto.com//attachment/website/file/user/2.png',
            },
            {
              name: 'content',
              children: (
                <>
                  <p>退款通知</p>
                </>
              ),
              className: 'k5m4woqrgwg-editor_css',
            },
          ],
        },
      },
      {
        name: 'block~k5m4y2ae4l6',
        className: 'content0-block',
        md: 6,
        xs: 12,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon k5m4wbf615g-editor_css',
              children:
                'https://www.wshoto.com//attachment/website/file/user/3.png',
            },
            {
              name: 'content',
              children: (
                <>
                  <p>流失回访</p>
                </>
              ),
              className: 'k5m4woqrgwg-editor_css',
            },
          ],
        },
      },
      {
        name: 'block~k5m4y2xxm1k',
        className: 'content0-block',
        md: 6,
        xs: 12,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon k5m4wbf615g-editor_css',
              children:
                'https://www.wshoto.com//attachment/website/file/user/4.png',
            },
            {
              name: 'content',
              children: (
                <>
                  <p>消费及复购回访</p>
                </>
              ),
              className: 'k5m4woqrgwg-editor_css',
            },
          ],
        },
      },
    ],
  },
};
export const Content110DataSource = {
  OverPack: {
    className: 'home-page-wrapper content11-wrapper k317ziqoic-editor_css',
    playScale: 0.3,
  },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <>
            <p>Hi，现在注册，享好礼！</p>
          </>
        ),
        className: 'title-h1 k318183k996-editor_css',
      },
    ],
  },
  button: {
    className: '',
    children: {
      a: {
        className: 'button',
        href: 'https://www.wshoto.com/wi_user_login.php',
        children: (
          <>
            <p>即刻开启私域</p>
          </>
        ),
        target: '_blank',
        type: 'default',
      },
    },
  },
};
export const Contact00DataSource = {
  wrapper: {
    className: 'home-page-wrapper content10-wrapper k32su1h3tc-editor_css',
  },
  Content: {
    className: 'icon-wrapper',
    children: {
      icon: {
        className: 'icon',
        children:
          'https://gw.alipayobjects.com/zos/rmsportal/zIUVomgdcKEKcnnQdOzw.svg',
        name: '主要图标',
      },
      iconShadow: {
        className: 'icon-shadow',
        children:
          'https://gw.alipayobjects.com/zos/rmsportal/WIePwurYppfVvDNASZRN.svg',
        name: '图标影阴',
      },
      url: {
        children:
          'https://router.map.qq.com/short?l=c68c329a0b1d624f863ff19911b71739',
        name: '跳转地址',
      },
      title: { children: '公司地址', name: '弹框标题' },
      content: {
        children: '微盛小程序 江苏微盛网络科技有限公司',
        name: '弹框内容',
      },
    },
  },
};
export const Footer10DataSource = {
  wrapper: { className: 'home-page-wrapper footer1-wrapper' },
  OverPack: { className: 'footer1', playScale: 0.2 },
  block: {
    className: 'home-page k317qox00p-editor_css',
    gutter: 0,
    children: [
      {
        name: 'block0',
        xs: 24,
        md: 6,
        className: 'block k319huz377-editor_css',
        title: {
          className: 'logo',
          children:
            'https://www.wshoto.com/resource/website_new/images/index-nav-logo.png',
        },
        childWrapper: {
          className: 'slogan k31a2k968um-editor_css',
          children: [
            {
              name: 'content0',
              children: (
                <>
                  <p>基于企业微信的行业SCRM解决方案</p>
                </>
              ),
              className: 'k31a2veocw6-editor_css',
            },
            {
              name: 'image~k319ceqayh',
              className: 'k319cpthlg-editor_css',
              children: '',
            },
            {
              name: 'image~k319cgwc11n',
              className: 'k319ciwpn89-editor_css',
              children: '',
            },
          ],
        },
      },
      {
        name: 'block1',
        xs: 24,
        md: 6,
        className: 'block k49b5xaw2ct-editor_css',
        title: {
          children: (
            <>
              <p>云业务</p>
            </>
          ),
        },
        childWrapper: {
          children: [
            {
              name: 'link0',
              href: 'https://www.wshoto.com/wi_website_qcloudso.php',
              children: (
                <>
                  <p>联合解决方案</p>
                </>
              ),
              className: 'k317s8b5dk8-editor_css',
              target: '_blank',
            },
            {
              name: 'link1',
              href: 'https://www.wshoto.com/wi_website_shopping.php',
              children: (
                <>
                  <p>优惠购买</p>
                </>
              ),
              className: 'k317scp5att-editor_css',
              target: '_blank',
            },
            {
              name: 'link~k32seujj06n',
              href:
                'https://qcloud.wshoto.com/wshotocloud/activity.wshotocloud.com/free_test/index.html',
              children: (
                <>
                  <p>免费体验</p>
                </>
              ),
              className: 'k317scp5att-editor_css',
              target: '_blank',
            },
          ],
          className: 'k317s8vk249-editor_css',
        },
      },
      {
        name: 'block2',
        xs: 24,
        md: 6,
        className: 'block',
        title: {
          children: (
            <>
              <p>招商加盟</p>
            </>
          ),
        },
        childWrapper: {
          children: [
            {
              href: 'https://www.wshoto.com/wi_website_joinin.php',
              name: 'link0',
              children: (
                <>
                  <p>产品优势</p>
                </>
              ),
              className: 'k49blu3q21f-editor_css',
            },
            {
              href: 'https://www.wshoto.com/wi_website_joinin.php',
              name: 'link1',
              children: (
                <>
                  <p>扶持体系</p>
                </>
              ),
              className: 'k49bmjmeku-editor_css',
            },
            {
              href: '#',
              name: 'link~k32seoc7wm',
              children: (
                <>
                  <p>
                    <br />
                  </p>
                </>
              ),
            },
          ],
        },
      },
      {
        name: 'block3',
        xs: 24,
        md: 6,
        className: 'block',
        title: {
          children: (
            <>
              <p>了解微盛</p>
            </>
          ),
        },
        childWrapper: {
          children: [
            {
              href: 'https://www.wshoto.com/wi_website_aboutus.php',
              name: 'link0',
              children: (
                <>
                  <p>关于我们</p>
                </>
              ),
              className: 'k319fv578f-editor_css',
            },
            {
              href: 'https://www.wshoto.com/wi_website_advantage.php',
              name: 'link1',
              children: (
                <>
                  <p>我们的优势</p>
                </>
              ),
              className: 'k49bnhbvx8-editor_css',
            },
            {
              href: 'https://www.wshoto.com/wi_website_news.php',
              name: 'link~k32sfv93meu',
              children: (
                <>
                  <p>新闻中心</p>
                </>
              ),
              className: 'k49bnjbtui9-editor_css',
            },
          ],
        },
      },
    ],
  },
  copyrightWrapper: { className: 'copyright-wrapper' },
  copyrightPage: { className: 'home-page' },
  copyright: {
    className: 'copyright k47vbijlci9-editor_css',
    children: (
      <>
        <p>
          Copyright ©江苏微盛网络科技有限公司{' '}
          <a
            href="http://www.beian.miit.gov.cn/state/outPortal/loginPortal.action"
            target="_blank"
            rel="noopener noreferrer"
          >
            苏ICP备15043910-2号
          </a>
        </p>
      </>
    ),
  },
};
